// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".circle-before[data-v-074bb0b9]:before{background-color:currentColor;border-radius:50%;content:\"\";display:inline-block;height:6px;margin-left:4px;width:6px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
